var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0879 15C18.1945 15 20.7129 12.4816 20.7129 9.375C20.7129 6.2684 18.1945 3.75 15.0879 3.75C11.9813 3.75 9.46289 6.2684 9.46289 9.375C9.46289 12.4816 11.9813 15 15.0879 15Z",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42432 26.25C5.42432 21.8963 9.75556 18.375 15.0881 18.375C16.1681 18.375 17.2143 18.5212 18.1931 18.7912",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3379 21.75C26.3379 22.11 26.2929 22.4587 26.2029 22.7962C26.1016 23.2462 25.9217 23.685 25.6854 24.0675C24.9092 25.3725 23.4804 26.25 21.8379 26.25C20.6791 26.25 19.6329 25.8112 18.8454 25.0912C18.5079 24.7987 18.2154 24.45 17.9904 24.0675C17.5741 23.3925 17.3379 22.5938 17.3379 21.75C17.3379 20.535 17.8216 19.4213 18.6091 18.6113C19.4304 17.7675 20.5779 17.25 21.8379 17.25C23.1654 17.25 24.3691 17.8238 25.1791 18.7463C25.8991 19.545 26.3379 20.6025 26.3379 21.75Z",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9968 20.5576L20.623 22.9314",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.645 20.5801L23.03 22.9538",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete_account.949ef071.svg";
export { ForwardRef as ReactComponent };